(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AnaliticalabController', AnaliticalabController)
 
    AnaliticalabController.$inject = ["GenerallabService","AnaliticalabService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function AnaliticalabController(GenerallabService,AnaliticalabService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.filtros = {};
        vm.ctXanual = "";
        vm.ctXlinea = "";
        vm.ctXCompra = "";
        vm.chartAnual = "";
        vm.chartCompra = "";
        vm.resultadoAnalitica = "";

        

		vm.generalLab = GenerallabService;

        vm.buscar = function(){
        	vm.initFacturacionAnual(false);
        	vm.initFacturacionCompra(false);
        	vm.initNumeroPeticiones(false);
        	vm.initPrecioCategoria(false);
        	vm.initValidadores(false);
        }

        vm.initSeguimientoAnalitica = function(){
        	AnaliticalabService.getInfoAnalitica(vm.filtros,function(data){
        		vm.resultadoAnalitica = data;
        	});
        }

        vm.initClientV = false;
        vm.initClientes = function(){
        	AnaliticalabService.getFacturacionClientes(vm.filtros,function(data){
        		if(!vm.initClientV){
					vm.ctXCompra = document.getElementById('chartclientes');
	        		vm.ctXCompra.height = 350;
	        		vm.ctXCompra = vm.ctXCompra.getContext('2d');
					vm.chartClientes = new Chart(vm.ctXCompra, {
					    type: 'horizontalBar',
					    data: {
					        labels: data.clientes,
					        datasets: [{
					            label: 'Cliente',
					            data: data.precios,
					            //backgroundColor: data.colors, 
					            borderWidth: 1
					        }]
					    },
					    options: {
					    	responsive: true,
					        scales: {
					            yAxes: [{
					                ticks: {
					                    beginAtZero: true,
					                    maxRotation: 0,
					                }
					            }]
					        }
					    }
					});
					vm.initClientV = true;
				}else{
					vm.chartClientes.data.labels = data.clientes;
					vm.chartClientes.data.datasets[0].data = data.precios;
					vm.chartClientes.update();
				}
			});
        }

        vm.initNum = false;
        vm.initNumeroPeticiones = function(init){
        	AnaliticalabService.getPeticionesLinea(vm.filtros,function(data){
	        	/**/
        		if(!vm.initNum){
					vm.ctXlinea = document.getElementById('chartlinea');
	        		vm.ctXlinea.height = 350;
	        		vm.ctXlinea = vm.ctXlinea.getContext('2d');

					vm.chartLinea = new Chart(vm.ctXlinea, {
					    type: 'line',
					    data: {
							datasets: data.dataset/*[{
								//backgroundColor: color(window.chartColors.red).alpha(0.5).rgbString(),
								//borderColor: window.chartColors.red,
								data: data.numero,
							
							}]*/
						},
					   options: {
					   	 legend: {
				            display: true,
				            labels: {
				                fontColor: 'rgb(255, 99, 132)'
				            }
				        },
					   	animation: {
							duration: 0
						},
				        scales: {
					        xAxes: [{
								type: 'time',
								//distribution: 'series',
								//offset: true,
								time: {
				                    unit: 'day',
				                    tooltipFormat: 'YYYY-MM-DD'
				                },
								/*ticks: {
									major: {
										enabled: true,
										fontStyle: 'bold'
									},
									source: 'data',
									autoSkip: true,
									autoSkipPadding: 75,
									maxRotation: 0,
									sampleSize: 100
								},*/
								
							}],
							yAxes: [{
								gridLines: {
									drawBorder: false
								},
								scaleLabel: {
									display: true,
									labelString: 'Número peticiones'
								}
							}]
				        },
				          tooltips: {
							intersect: false,
							mode: 'x',
							callbacks: {
								label: function(tooltipItem, myData) {
									//console.log(myData);
									//console.log(tooltipItem);
									var label = myData.datasets[tooltipItem.datasetIndex].label || '';
									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel+" peticiones "+myData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].label;
									return label;
								}
							}
						}
				    },
					  
					});
					vm.initNum = true;
				}else{
					//vm.chartLinea.data.labels = data.labels;
					if(typeof(vm.chartLinea.data.datasets)=='undefined'){
						vm.chartLinea.data.datasets = data.dataset
					}else{
						vm.chartLinea.data.datasets = data.dataset
					}
					vm.chartLinea.update();
				}
			});
        }

        vm.ctxCatPre = "";
        vm.initCat = false;
        vm.initPrecioCategoria = function(init){
        	AnaliticalabService.getPrecioCategoria(vm.filtros,function(data){

        		if(!vm.initCat){
	        		vm.ctxCatPre = document.getElementById('chartpreciocat');
	        		vm.ctxCatPre.height = 350;
	        		vm.ctxCatPre = vm.ctxCatPre.getContext('2d');

					
					vm.chartPrecat = new Chart(vm.ctxCatPre, {
					    type: 'bar',
					    data: {
					        labels: data.categorias,
					        datasets: data.dataset/*[{
					            label: 'Facturación Por categoría',
					            data: data.precios,
					            borderWidth: 1
					        }]*/
					    },
					    options: {
  							scaleShowValues: true,
					        scales: {
					            yAxes: [{
					                ticks: {
					                    beginAtZero: true
					                }
					            }],
					            xAxes: [{
							      ticks: {
							        autoSkip: false
							      }
							    }]
					        }
					    }
					});
					vm.initCat = true;
				}else{
					vm.chartPrecat.data.labels = data.categorias;
					vm.chartPrecat.data.datasets[0].data = data.dataset[0].data;
					vm.chartPrecat.update();
				}
	        	/**/
        		/*if(init){
					vm.ctxCatPre = document.getElementById('chartpreciocat');
	        		vm.ctxCatPre.height = 350;
	        		vm.ctxCatPre = vm.ctxCatPre.getContext('2d');

					vm.chartpreciocat = new Chart(vm.ctxCatPre, {
					    type: 'line',
					    data: {
							datasets: data.dataset
						},
					   options: {
					   	 legend: {
				            display: true,
				            labels: {
				                fontColor: 'rgb(255, 99, 132)'
				            }
				        },
					   	animation: {
							duration: 0
						},
				        scales: {
					        xAxes: [{
								type: 'time',
								//distribution: 'series',
								//offset: true,
								time: {
				                    unit: 'day',
				                    tooltipFormat: 'YYYY-MM-DD'
				                },
								
								
							}],
							yAxes: [{
								gridLines: {
									drawBorder: false
								},
								scaleLabel: {
									display: true,
									labelString: 'Precio por categorías'
								}
							}]
				        },
				          tooltips: {
							intersect: false,
							mode: 'x',
							callbacks: {
								label: function(tooltipItem, myData) {
									//console.log(myData);
									//console.log(tooltipItem);
									var label = myData.datasets[tooltipItem.datasetIndex].label || '';
									if (label) {
										label += ': ';
									}
									label += tooltipItem.yLabel+" peticiones "+myData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].label;
									return label;
								}
							}
						}
				    },
					  
					});
				}else{
					//vm.chartpreciocat.data.labels = data.labels;
					if(typeof(vm.chartpreciocat.data.datasets)=='undefined'){
						vm.chartpreciocat.data.datasets = data.dataset
					}else{
						vm.chartpreciocat.data.datasets = data.dataset
					}
					vm.chartpreciocat.update();
				}*/
			});
        }

        function getRandomColor() {
             return 'rgb('
      + Math.round(Math.random() *255) + ','
      + Math.round(Math.random() *255) + ','
      + Math.round(Math.random() *255) + ','
      + '1)';
        }

        vm.initVal = false;
        vm.initValidadores =function(){
        	AnaliticalabService.getValidadores(vm.filtros,function(data){
        		var colors = [];
        		for(var cont=0;cont<data.datasets[0].data.length;cont++){
        			colors.push(getRandomColor());
        		}
        		data.datasets[0].backgroundColor = colors;
        		//console.log(data);
        		if(!vm.initVal){
	        		vm.ctXVal = document.getElementById('chartval');
	        		vm.ctXVal.height = 350;
	        		vm.ctXVal = vm.ctXVal.getContext('2d');

					
					vm.chartValid = new Chart(vm.ctXVal, {
					    type: 'pie',
					    data: {
					        labels: data.labels,
					        datasets: data.datasets
					    },
					    options: {
					   	 legend: {
				            display: true,
				            labels: {
				                fontColor: 'rgb(255, 99, 132)'
				            }
				        }
				        }/*,
					    options: {
					        scales: {
					            yAxes: [{
					                ticks: {
					                    beginAtZero: true
					                }
					            }]
					        }
					    }*/
					});
					vm.initVal = true;
				}else{
					vm.chartValid.data.labels = data.labels;
					vm.chartValid.data.datasets[0].data = data.datasets[0].data;
					vm.chartValid.update();
				}
        	})
        }

        vm.seguimiento = {}
        vm.initSeguimientolab = function(init){
        	AnaliticalabService.getSeguimientolab(vm.filtros,function(data){
        		vm.seguimiento = data;
        	});
        }

        vm.seguimientocat = {}
        vm.initSeguimientoCat = function(init){
        	AnaliticalabService.getSeguimientocat(vm.filtros,function(data){
        		vm.seguimientocat = data;
        	});
        }
        

       	vm.initFAn = false;
        vm.initFacturacionAnual = function(init){
        	AnaliticalabService.getFacturacionAnual(vm.filtros,function(data){
        		if(!vm.initFAn){
	        		vm.ctXanual = document.getElementById('myChart');
	        		vm.ctXanual.height = 350;
	        		vm.ctXanual = vm.ctXanual.getContext('2d');

					
					vm.chartAnual = new Chart(vm.ctXanual, {
					    type: 'bar',
					    data: {
					        labels: data.meses,
					        datasets: [{
					            label: 'Facturación',
					            data: data.precios,
					            borderWidth: 1
					        }]
					    },
					    options: {
					        scales: {
					            yAxes: [{
					                ticks: {
					                    beginAtZero: true
					                }
					            }]
					        }
					    }
					});
					vm.initFAn = true;
				}else{
					vm.chartAnual.data.labels = data.meses;
					vm.chartAnual.data.datasets[0].data = data.precios;
					vm.chartAnual.update();
				}
        	})
        }

        vm.initFac = false;
        vm.initFacturacionCompra = function(init){
        	AnaliticalabService.getFacturacionCompra(vm.filtros,function(data){
	        	/*var ctxLine = document.getElementById('lineChart').getContext('2d');
				var stackedLine = new Chart(ctxLine, {
				    type: 'line',
				    data: {
						labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'Ag', 'Sep', 'Oc', 'Nov','Dic'],
						datasets: data.result
					},
				    options: {
				        scales: {
				            yAxes: [{
				                stacked: true
				            }]
				        }
				    }
				});*/
        		if(!vm.initFac){
					vm.ctXCompra = document.getElementById('lineChart');
	        		vm.ctXCompra.height = 350;
	        		vm.ctXCompra = vm.ctXCompra.getContext('2d');
					vm.chartCompra = new Chart(vm.ctXCompra, {
					    type: 'horizontalBar',
					    data: {
					        labels: data.grupocompra,
					        datasets: [{
					            label: 'Grupo de compra',
					            data: data.precios,
					            //backgroundColor: data.colors, 
					            borderWidth: 1
					        }]
					    },
					    options: {
					    	responsive: true,
					        scales: {
					            yAxes: [{
					                ticks: {
					                    beginAtZero: true,
					                                maxRotation: 0,

					                }
					            }]
					        }
					    }
					});
					vm.initFac = true;
				}else{
					vm.chartCompra.data.labels = data.grupocompra;
					vm.chartCompra.data.datasets[0].data = data.precios;
					vm.chartCompra.update();
				}
			});
        }
        
    }
  
})();